import type { Result } from '@/shared/types/result'
import type { ApiError } from '@/shared/types/errors'
import { unwrapResult } from './unwrapResult'

/**
 * Wrap a no-arg API function returning Result into a queryFn that throws on error.
 * Eliminates the repeated pattern:
 *   `const result = await fn(); if (isOk(result)) return result.value; throw new Error(...)`
 */
export function resultQueryFn<T>(
  fn: () => Promise<Result<T, ApiError>>,
): () => Promise<T> {
  return async () => unwrapResult(await fn())
}

/**
 * Wrap a single-arg API function returning Result into a mutationFn.
 */
export function resultMutationFn<TArg, TResult>(
  fn: (arg: TArg) => Promise<Result<TResult, ApiError>>,
): (arg: TArg) => Promise<TResult> {
  return async (arg) => unwrapResult(await fn(arg))
}
